import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { QuestionBase, FormQuestionsService } from '../../core/index';
import { ProfileService } from 'core/services';
import { DefaultCoursesQuestionsService } from '../questions-services/default-courses-questions.service';
import { AdminCoursesQuestionsService } from '../questions-services/admin-courses-questions.service';
import { PartnerCoursesQuestionsService } from '../questions-services/partner-courses-questions.service';
import { ClientCoursesQuestionsService } from '../questions-services/client-courses-questions.service';
import { CsCoursesQuestionsService } from '../questions-services/cs-courses-questions.service';
import { ROLE_MAP, UserGroups } from '../assets/constants';
import { RootCoursesQuestionsService } from '../questions-services/root-courses-questions.service';

@Injectable({
  providedIn: 'root'
})
export class CoursesQuestionsService implements FormQuestionsService {
  private delegatedQuestionsService: DefaultCoursesQuestionsService;
  private userGroup: string;
  private servicesMap: any;

  constructor(
    protected profileService: ProfileService,
    protected translate: TranslateService,
    protected rootCoursesQuestionsService: RootCoursesQuestionsService,
    protected adminCoursesQuestionsService: AdminCoursesQuestionsService,
    protected csCoursesQuestionsService: CsCoursesQuestionsService,
    protected partnerCoursesQuestionsService: PartnerCoursesQuestionsService,
    protected clientCoursesQuestionsService: ClientCoursesQuestionsService
  ) {
    this.servicesMap = {
      root: this.rootCoursesQuestionsService,
      admin: this.adminCoursesQuestionsService,
      global: this.csCoursesQuestionsService,
      partner: this.partnerCoursesQuestionsService,
      client: this.clientCoursesQuestionsService
    };

    this.profileService.getLoggedUser$().subscribe((loggedUser) => {
      const { scope, name } = loggedUser.roleOptions;
      const userGroupMap = { csAdmin: UserGroups.Admin };
      this.userGroup = userGroupMap[name] || scope;
      this.setDelegatedQuestionsService();
    });
  }

  private setDelegatedQuestionsService() {
    this.delegatedQuestionsService = this.servicesMap[this.userGroup];
  }

  public getFormQuestions(params: any = {}): Observable<QuestionBase<any>[]> {
    return this.delegatedQuestionsService.getFormQuestions(params);
  }

  public setForm(form: UntypedFormGroup) {
    this.delegatedQuestionsService.setForm(form);
  }

  public onDataChanged(newData: any): void {
    this.delegatedQuestionsService.onDataChanged(newData);
  }

  public getFormData(): void {
    this.delegatedQuestionsService.getFormData();
  }

  public getSubmitAction(): string {
    return ROLE_MAP[this.userGroup];
  }
}
